import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/app/game/page.tsx");
